module.exports = __webpack_public_path__ + "img/526.04df0ba1.jpg";